<template>
  <Dialog :title="title" :width="600" :height="400" :visible="dialogVisible" @close="handleClose">
    <div class="grid-contain">
      <div class="operation" v-if="this.defaultCondition">
        <el-form v-for="(con, index) in defaultCondition" size="mini" :inline="true" class="demo-form-inline"
                 :key="index">
          <el-form-item :label="con.label">
            <el-input v-model="params[con.key]" :placeholder="con.placeholder?con.placeholder:'请输入查询内容'"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="selectBtn" type="primary" size="medium" style="float: right;" icon="el-hg-icon-search"
                       @click="handleSelect">搜索
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="grid-table" v-loading="loading">
        <sp-table
          ref="gridTable"
          :parentTableData.sync="tableData"
          :parentCol.sync="gridConfigCopy"
          :dragDrop='true'
          height="100%"
          @selection-change="handleSelectionChange"
          @getDetail="handleOk"
          :key-dom=-1
        >
          <el-table-column align="center" type="selection" class="selection"></el-table-column>
          <el-table-column align="center" type="index" width="50" label="序号"></el-table-column>
          <sp-table-column :align="item.titleAlignment" v-for="(item, index) in gridConfig" :key="index"
                           :width="item.displayWidth"
                           sortable
                           :prop="gridConfig[index].fieldName"
          >
            <template slot="header">
              <p>{{item.fieldAlias}}</p>
            </template>
            <template v-slot="{ scope }">
              <div class="span" :style="{textAlign: item.alignment}">
                <div v-if="gridConfig[index].fieldType===5">
                  <i v-if="scope.row[gridConfig[index].fieldName]==true" class="columnIcon el-icon-check"></i>
                  <i v-else class="columnIcon el-icon-close"></i>
                </div>
                <div v-else> {{scope.row[gridConfig[index].fieldName]}}</div>
              </div>
            </template>
          </sp-table-column>
        </sp-table>
      </div>
    </div>
    <div slot="footer" style="width:100%;text-align: right">
      <el-button size="small" icon="el-hg-icon-save" type="primary" @click="handleOk">选 择</el-button>
      <el-button size="small" icon="el-hg-icon-close" type="danger" @click="handleClose">关 闭</el-button>
    </div>
  </Dialog>
</template>
<script>
  import {mapGetters} from 'vuex';
  import Dialog from '@/components/dialog';
  import {spTable, spTableColumn} from '@/components/sptable';

  export default {
    components: {
      Dialog,
      spTable,
      spTableColumn,
    },
    props: {
      dataUpdate: Boolean,
      gridConfig: {
        type: Array,
        default: () => [],
      },
      defaultParams: {
        url: '',
        params: {},
      },
      defaultCondition: {
        type: Array,
        default: () => [],
      },
      defaultValues: [Object, String, Array],
      defaultKeys: [Object, String, Array],
      refValue: {
        type: Object,
        default: () => {
        },
      },
      refList: {
        type: Array,
        default: () => [],
      },
      refListIndex: Number,
      col: {
        type: Array,
        default: () => [],
      },
      pageType: String,
      title: {
        type: String,
        default: '弹出框',
      },
      show: {
        type: Boolean,
        default: true,
      },
      addData: {
        type: Function
      },
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
      }),
    },
    data() {
      return {
        dialogVisible: this.show,
        inputVal: '',
        tableData: [],
        loading: false,
        selectList: [],
        params: {},
        gridConfigCopy: [],
        defaultParamsValue: {}
      };
    },
    created() {
      this.defaultParamsValue = this.defaultParams;
    },
    watch: {
      defaultParams: {
        deep: true,
        handler: function (val) {
          this.defaultParamsValue = val;
          !this.dataUpdate ? this._getDataList() : '';
        },
      },
      show(val) {
        this.dialogVisible = !!val;
        if (this.dialogVisible) {
          this.initParams();
          this._getDataList();
        }
      },
      gridConfig(val) {
        this.initCol()
      },
      gridConfigCopy() {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
    },
    methods: {
      initCol() {
        this.gridConfig.length > 0
        && (this.gridConfigCopy = this.gridConfig.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            return info;
          })
        );
      },
      init() {
        this.selectList = this.tableData.filter(ref => {
          return this.defaultKeys && this.defaultValues && ref[this.defaultKeys] && this.defaultValues[this.defaultKeys] && ref[this.defaultKeys] === this.defaultValues[this.defaultKeys];
        });
        this.$refs.gridTable ? this.$refs.gridTable.initSelect(this.selectList) : '';
      },
      initParams() {
        this.defaultCondition.forEach(condition => {
          this.$set(this.params, condition.key, condition.value);
        });
      },
      async _getDataList() {
        if (!this.defaultParamsValue) return;
        this.loading = true;
        let {url, type, params} = this.defaultParamsValue;
        params = Object.assign({}, params, this.params);
        for (let key in params) {
          params[key] && typeof params[key] === 'string' ? params[key] = params[key].trim() : '';
        }
        const {bean} = await this.$services.post({
          url,
          type,
          params: Object.assign({}, params, {accountId: this.userInfor && this.userInfor.accountId})
        });
        //新增时弹出选择的数据只有一条时，将数据直接赋值到页面
        if (bean.length === 1 && this.pageType === 'add') {
          let refValue = {};
          let re = true;
          Object.keys(this.defaultValues).forEach(key => {
            //number canNumber不对应导致canNumber被覆盖问题添加判断条件
            !(this.defaultValues[key] === 'CanNumber' && key === 'Number') ? refValue[this.defaultValues[key]] = bean[0][key] : '';
            //相等不再赋值，避免监听造成死循环
            this.refValue && refValue && this.refValue[this.defaultValues[key]] === refValue[this.defaultValues[key]] ? re = false : '';
          });
          if (re) {
            this.refValue ? this.$emit('update:refValue', Object.assign({}, this.refValue, refValue)) : '';
            this.refList.length > 0 ? this.$emit('update:refList', [Object.assign({}, this.refList[this.refListIndex], refValue, {updateFlg: 'add'})]) : '';
          }
        }
        this.tableData = bean;
        this.init();
        this.loading = false;
        this.$nextTick(() => {
          this.$refs.gridTable ? this.$refs.gridTable.initTable() : '';
        });
      },
      // 选中列数据
      selectData() {
      },
      // 搜索方法
      handleSelect() {
        this._getDataList(this.inputVal);
      },
      // dialog 关闭
      handleClose() {
        this.$emit('close', false);
      },
      // 分页
      pageChange(val) {
        this.$emit('page', val);
      },
      handleOk() {
        console.log('回写数据====>开始', this.selectList);
        let refValue = {};
        this.selectList.forEach((select, i) => {
          i !== 0 ? this.addData('', select) : Object.keys(this.defaultValues).forEach(key => {
            //number canNumber不对应导致canNumber被覆盖问题添加判断条件
            !(this.defaultValues[key] === 'CanNumber' && key === 'Number') ? refValue[this.defaultValues[key]] = select[key] : '';
          });
        });
        if (this.refList.length > 0) {
          const refList = JSON.parse(JSON.stringify(this.refList));
          console.log(refValue);
          Object.assign(refList[this.refListIndex], refValue);
          // refList[this.refListIndex] = refValue;
          this.$emit('update:refList', refList);
        }
        else {
          this.$emit('update:refValue', Object.assign({}, this.refValue, refValue));
        }
        const defaultCondition = JSON.parse(JSON.stringify(this.defaultCondition));
        defaultCondition.forEach(condition => {
          condition.value = this.params[condition.key];
        });
        this.$emit('update:defaultCondition', defaultCondition);
        this.$emit('close', false);
        console.log('回写数据====>结束', refValue);
      },
      handleSelectionChange(val) {
        this.selectList = val;
      },
    },
  };
</script>
<style lang="scss">
  .grid-contain {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;

    .columnIcon {
      font-size: 16px;
      font-weight: bold;
      &.el-icon-check {
        color: #16ba16;
      }
      &.el-icon-close {
        color: #ff6464;
      }
    }

    .operation {
      margin-bottom: 20px;
      padding-left: 20px;

      .el-form-item__label {
        line-height: 32px;
      }
      .el-form-item__content {
        vertical-align: sub;
      }
    }

    .gdConent-input {
      width: 200px;
    }

    .grid-table {
      flex: 1;
      overflow: hidden;
    }
  }

  .selectBtn {
    margin-top: 5px;
    vertical-align: text-top;
  }
</style>
